import { ILLGenericKeys } from './index';

export class ILLPackage {
 level: string;
 type: ILLGenericKeys;
 quantityValue: string;
 quantityUnit: ILLGenericKeys;
 code: string;
 packageDetailId: number;
}